import { jsx as o } from "react/jsx-runtime";
import r from "./HeaderButton.js";
const a = ({
  onClick: e,
  className: t = "btn_close",
  ...n
}) => /* @__PURE__ */ o(r, { className: t, onClick: e, ...n, children: /* @__PURE__ */ o("span", { className: "icon icon_close", children: "페이지 닫기" }) });
export {
  a as default
};
